import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StatusIndicator from 'components/application/indicators/StatusIndicator';

import { formatDate } from 'components/helpers/dates';
import { resourceShape } from 'components/helpers/serialisableResources';

const statusClassNames = {
  grey: 'tw-bg-grey-050 tw-text-grey-700',
  high: 'tw-bg-red-025 tw-text-red-800',
  low: 'tw-bg-green-025 tw-text-green-800',
  medium: 'tw-bg-amber-025 tw-text-amber-800',
};
export default function CombinedStatus({
  currentTrainingStatus,
  isRequired,
  latestTraining,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const expiryDate = latestTraining?.attributes?.expiryDate;

  const formattedExpiryDate =
    expiryDate && formatDate({ date: expiryDate, format: 'd MMM yyyy' });

  const trainingStatusOptions = {
    valid: {
      status: 'low',
      text:
        expiryDate ?
          i18nTShared('expiresDate', { date: formattedExpiryDate })
        : i18nTShared('doesNotExpire'),
    },
    expiryDateMissing: {
      status: isRequired ? 'high' : 'grey',
      text: i18nTShared('expiryDateIsMissing'),
    },
    expiring: {
      status: isRequired ? 'medium' : 'low',
      text: i18nTShared('expiresDate', { date: formattedExpiryDate }),
    },
    expired: {
      status: isRequired ? 'high' : 'grey',
      text: i18nTShared('expiredDate', { date: formattedExpiryDate }),
    },
    invalid: {
      status: isRequired ? 'high' : 'grey',
      text: i18nTShared('expiryDateNotSet'),
    },
    missing: {
      status: isRequired ? 'high' : 'grey',
      text: i18nTShared('missing'),
    },
  };

  const { status, text } = trainingStatusOptions[currentTrainingStatus];

  return (
    <div
      className={classNames(
        'tw-inline-flex tw-h-8 tw-items-center tw-rounded-full tw-px-3',
        statusClassNames[status],
      )}
    >
      <StatusIndicator status={status} />
      <span className='tw-ml-2'>{text}</span>
    </div>
  );
}

CombinedStatus.propTypes = {
  currentTrainingStatus: PropTypes.string.isRequired,
  latestTraining: resourceShape('training'),
  isRequired: PropTypes.bool,
};
